import React, { useEffect, useState } from "react";
import { route } from "./routes/Route";
import { RouterProvider } from "react-router-dom";
import "./styles/style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { ToastContainer } from "react-toastify";
import CourseApi from "./api/services/CourseApi";
import useUserStore from "./stores/useUserStore";
import Loader from "./components/microComponents/Loader";
import useAppStore from "./stores/useAppStore";
import ModalReact from "./components/microComponents/ModalReact";
import useTitle from "./hooks/useTitle";

function App() {
  useTitle("Home");

  const indicator = useAppStore((state) => state.indicator);
  const setPatenteLessons = useUserStore((state) => state.setPatenteLessons);
  const [isLoading, setIsLoading] = useState(true);

  const showTranslatePopover = useAppStore(
    (state) => state.showTranslatePopover
  );
  const setShowTranslatePopover = useAppStore(
    (state) => state.setShowTranslatePopover
  );
  const translateObject = useAppStore((state) => state.translateObject);

  useEffect(() => {
    fetchApiData();
  }, []);

  const fetchApiData = () => {
    CourseApi.getAllcourse({
      showIndicator: true,
      onSuccess: (respose) => {
        setPatenteLessons(respose.data[0]);
        setIsLoading(false);
      },
      onError: () => {
        setIsLoading(false);
      },
    });
  };

  return (
    <div className="App">
      {indicator ? <Loader /> : <RouterProvider router={route} />}

      <ModalReact
        show={showTranslatePopover}
        onHide={() => setShowTranslatePopover(false)}
        fromText={translateObject.fromText}
        toText={translateObject.toText}
      />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
